<template>
  <v-row style="max-width: 600px; margin: 0 auto;">
    <v-col id="base" md="12" style="display: flex; flex-flow: column; height: 100%;" class="mt-0 pt-0" >
      <!-- Header -->
      <v-row justify="center" align="start" style="background-color: white; border-bottom: 3px solid #E8E8E8; height: 80px">
        <v-col class="ml-4 mt-0 pt-1 RestoRegular">
          <v-row  style="font-size: 18px; color: #4D4D4D; max-width: 300px" class="pt-2">Por favor agrega tu método de pago</v-row>
          <!-- <v-snackbar v-model="isError" :top="true" color="error">¡Falta llenar algún campo!</v-snackbar> -->
          <!-- <v-snackbar
            v-model="isError2"
            :top="true"
            color="error"
          >¡Error! Por favor verifica tu número de cuenta y tu CVV</v-snackbar> -->
          <!-- <v-snackbar v-model="alert" :top="true" color="error">{{ alertmensaje }}</v-snackbar> -->
        </v-col>
      </v-row>

      <!-- New content -->
      <v-row style="flex-grow : 1;" class="py-0 my-0" >
          <v-col style="height: 100%" class="py-0 my-0 mt-5">

              <form action="" method="post" id="pay" name="pay" >
                    <p v-show="false">
                        <label for="description">Descripción</label>                        
                        <input type="text" name="description" id="description" value="Ítem seleccionado"/>
                    </p>                    
                    <p v-show="false">
                        <label for="transaction_amount">Monto a pagar</label>                        
                        <input name="transaction_amount" id="transaction_amount" value="1"/>
                    </p>
                    <v-row style="max-width: 350px; margin: 0 auto;">
                        <v-text-field v-model="card.alias"  :rules="[rules.required]" label="Alias de la tarjeta" outlined class="mt-1 mb-2" hide-details='true'></v-text-field>
                    </v-row>
                    <v-row style="max-width: 350px; margin: 0 auto;">
                        <v-text-field v-model="card.num" id="selector" label="Número de la tarjeta" outlined class="mt-1 mb-2" hide-details='true'></v-text-field>
                    </v-row>
                    <p v-show="false">
                        <label for="cardNumber">Número de la tarjeta</label>
                        <input type="text" v-model="card.num" id="cardNumber" data-checkout="cardNumber" onselectstart="return false" onpaste="return false" onCopy="return false" onCut="return false" onDrag="return false" onDrop="return false" autocomplete=off />
                    </p>
                    <v-row style="max-width: 350px; margin: 0 auto;">
                        <v-text-field v-model="card.name" :rules="[rules.required]" label="Nombre que aparece en la tarjeta" outlined class="mt-1 mb-2" hide-details='true'></v-text-field>
                        <!-- <input data-checkout="cardholderName" id="" v-model="card.name" type="text" v-show="false"/> -->
                    </v-row>
                    <p v-show="false">
                        <label for="cardholderName">Nombre y apellido</label>
                        <input type="text" v-model="card.name"  id="cardholderName" data-checkout="cardholderName" />
                    </p>             
                      <v-row style="margin: 0 auto; max-width: 350px;" class="my-0 py-0">
                        <v-col class="pl-0">
                            <v-text-field v-model="card_exp" id="cardExp" label="Expiración" placeholder="MM-AA" hint="MM-AA" outlined class="mt-1 mb-0"></v-text-field>
                             <!-- <input v-model="year" id="cardExpirationYear" data-checkout="cardExpirationYear" v-show="false" type="text" />
                             <input v-model="month" id="cardExpirationMonth" data-checkout="cardExpirationMonth" v-show="false" type="text" /> -->
                        </v-col>
                        <v-col class="pr-0">
                            <v-text-field
                                v-model="card.cvv"
                                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="showPassword ? 'text' : 'password'"
                                label="CVV"
                                :rules="[rules.required,rules.cvv]"
                                outlined
                                id="cvv4"
                                class="mt-1 mb-2"
                                hide-details='true'
                                @click:append="showPassword = !showPassword"
                            ></v-text-field>
                            <!-- <input v-model="card.cvv" id="securityCode" data-checkout="securityCode" v-show="false" type="text" /> -->
                        </v-col>
                    </v-row>                
                    <p v-show="false">
                        <label for="cardExpirationMonth">Mes de vencimiento</label>
                        <input type="text" v-model="month"  id="cardExpirationMonth" data-checkout="cardExpirationMonth" onselectstart="return false" onpaste="return false" onCopy="return false" onCut="return false" onDrag="return false" onDrop="return false" autocomplete=off />
                    </p>
                    <p v-show="false">
                        <label for="cardExpirationYear">Año de vencimiento</label>
                        <input type="text" v-model="year" id="cardExpirationYear" data-checkout="cardExpirationYear" onselectstart="return false" onpaste="return false" onCopy="return false" onCut="return false" onDrag="return false" onDrop="return false" autocomplete=off />
                    </p>
                    <p v-show="false">
                        <label for="securityCode">Código de seguridad</label>
                        <input type="text" v-model="card.cvv" id="securityCode" data-checkout="securityCode" onselectstart="return false" onpaste="return false" onCopy="return false" onCut="return false" onDrag="return false" onDrop="return false" autocomplete=off />
                    </p>
                    <p v-show="false">
                        <label for="installments">Cuotas</label>
                        <select id="installments" class="form-control" name="installments"></select>
                    </p>
                    <p v-show="false">
                        <label for="docType">Tipo de documento</label>
                        <select id="docType" data-checkout="docType"></select>
                    </p>
                    <p v-show="false">
                        <label for="docNumber">Número de documento</label>
                        <input type="text" id="docNumber" data-checkout="docNumber"/>
                    </p>
                    <p v-show="false" >
                        <label for="email">Email</label>
                        <input type="email" id="email" name="email" :value="email"/>
                    </p>  
                    <input type="hidden" name="payment_method_id" id="payment_method_id"/>
                    <input v-show="false"  type="submit" value="Pagar"/>
            </form>
            <v-row justify="center" class="pr-2 mb-12">
                <v-btn :loading="loading"  @click="generateToken" :color="$store.state.colors.primary" style="color: white; width: 85%; max-width: 350px;" class="buttonLower">
                    Agregar
                </v-btn>
            </v-row>

              <!-- <form action id="form-pagar-mp" style="height: 100%">
                  <v-row style="max-width: 350px; margin: 0 auto;">
                        <v-text-field v-model="card.name" :rules="[rules.required]" label="Nombre que aparece en la tarjeta" outlined class="mt-1 mb-2" hide-details='true'></v-text-field>
                        <input data-checkout="cardholderName" id="" v-model="card.name" type="text" v-show="false"/>
                    </v-row>
                    <v-row style="max-width: 350px; margin: 0 auto;">
                        <v-text-field v-model="card.num" data-checkout="cardNumber" id="cardNumber" name="cardNumber" type="text" :rules="[rules.required,rules.card]" label="Número de tarjeta" @keyup="print()" outlined class="mt-1 mb-2" hide-details='true'></v-text-field>
                        COMENTAR <input data-checkout="cardNumber" id="cardNumber" name="cardNumber" type="text" v-model="card.num" v-show="true"/>
                    </v-row>
                    <v-row style="margin: 0 auto; max-width: 350px;" class="my-0 py-0">
                        <v-col class="pl-0">
                            <v-text-field v-model="card_exp" label="Expiración" placeholder="mm/aa" :rules="[rules.required,rules.exp]" id="dateexp" class="mt-1 mb-2" hide-details='true' outlined></v-text-field>
                             <input v-model="year" id="cardExpirationYear" data-checkout="cardExpirationYear" v-show="false" type="text" />
                             <input v-model="month" id="cardExpirationMonth" data-checkout="cardExpirationMonth" v-show="false" type="text" />
                        </v-col>
                        <v-col class="pr-0">
                            <v-text-field
                                v-model="card.cvv"
                                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="showPassword ? 'text' : 'password'"
                                label="CVV"
                                :rules="[rules.required,rules.cvv]"
                                outlined
                                id="cvv4"
                                class="mt-1 mb-2"
                                hide-details='true'
                                @click:append="showPassword = !showPassword"
                            ></v-text-field>
                            <input v-model="card.cvv" id="securityCode" data-checkout="securityCode" v-show="false" type="text" />
                        </v-col>
                    </v-row>
                    <v-row style="max-width: 350px; margin: 0 auto;">
                        <br><br>
                        <p>
                            <input type="hidden" name="payment_method_id" id="payment_method_id"/>
                            <input type="submit" value="Realizar Pago" />
                        </p>
                    </v-row>
                    
              </form> -->
          </v-col>
      </v-row>
      <v-row justify="center" style="max-height: 70px; margin: 0 auto; width: 100%"  >
          <v-btn @click="$router.push({ name: 'userprofile'}); " class="text-left buttonLower" :color="$store.state.colors.primary" dark x-large style="width: 94%; height: 55px;  ">
              <span style="float: left; padding-left:0px;">Regresar</span>
              <v-spacer></v-spacer>
          </v-btn>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
// import $ from "jquery";
// require("jquery-mask-plugin");
import axios from "axios";
import Inputmask from "inputmask";

export function dateMask(value) {
  const hours = [/[0-1]/, value.charAt(0) === "0" ? /[1-9]/ : /[0-2]/];
  const minutes = [/[0-9]/, /[0-9]/];
  return value.length > 2 ? [...hours, "/", ...minutes] : hours;
}
export function rangeMask(value) {
  const numbers = value.replace(/[^0-9]/g, "");
  return [...dateMask(numbers)];
}

export default {
  data() {
    return {
      loading: false,
      userCards: JSON.parse(localStorage.getItem('userCards')),
      route: "userprofile",
      month:'',
      year:'',  
      showPassword: false,
      mask: rangeMask,
      card_exp: null,
      key: "",
      email: localStorage.getItem('email'),
      card: {
        _id: "",
        alias: "",
        name: "",
        num: "",
        exp: "",
        cvv: "",
        token:"",
      },
      rules: {
        card: v =>
          v
            ? (v.length >= 18 && v.length <= 19) ||
              "Minimo 15 caracteres máximo 16"
            : true,
        exp: v => (v ? v.length >= 5 || "Coloca la expiración completa" : true),
        cvv: v =>
          v
            ? (v.length >= 3 && v.length <= 4) || "Minimo 3 caracteres máximo 4"
            : true,
        required: value => !!value || ""
      },
      isError: false,
      isError2: false,
      alert: false,
      alertmensaje: "Ocurrió un error"
    };
  },
  mounted() {
    var cn = document.getElementById("selector");
    var cnm = new Inputmask("9999-9999-9999-9999",{placeholder: " "});
    cnm.mask(cn);
    var ex = document.getElementById("cardExp");
    // var exm = new Inputmask({regex:"^(0[1-9]|1[012])-\\d\\d$",placeholder: " "});
    var exm = new Inputmask("99-99",{placeholder: ""});
    exm.mask(ex);
    var cv = document.getElementById("cvv4");
    var cvm = new Inputmask("9999",{placeholder: ""});
    cvm.mask(cv);
    document.querySelector('#selector').addEventListener('keyup', changeMask);
    document.querySelector('#selector').addEventListener('change', changeMask);
    function changeMask(event) {
      console.log("Event",event);
      let selector = document.getElementById("selector").value;
      console.log("selector",selector.replace(/\s/g, '').length);
      if(selector.replace(/\s/g, '').length==19){
        var cv = document.getElementById("cvv4");
        var cvm = new Inputmask("999",{placeholder: ""});
        cvm.mask(cv);
      }else{
        var cv2 = document.getElementById("cvv4");
        var cvm2 = new Inputmask("9999",{placeholder: ""});
        cvm2.mask(cv2);
      }
    }
    // $("document").ready(function() {
    //   $("#cardNumber").mask("0000-0000-0000-0000");
    //   $("#cvv4").mask("0000");
      // var options =  {
      //     onKeyPress: function(cep, e, field, options) {
      //         var masks = ['00000-000', '0-00-00-00'];
      //         var mask = (cep.length>7) ? masks[1] : masks[0];
      //         $('#dateexp').mask(mask, options);
      //     }
    //   // };
    //   $("#dateexp").mask("ab/00", {
    //     translation: {
    //       a: {
    //         pattern: /[0-1]/
    //       },
    //       b: {
    //         pattern: /[1-9]/
    //       },
    //       c: {
    //         pattern: /[0-2]/
    //       }
    //     },
    //     onKeyPress: function(cep, e, field, options) {
    //       var masks = ["ab-00", "ac-00"];
    //       var mask = cep[0] == 1 ? masks[1] : masks[0];
    //       $("#dateexp").mask(mask, options);
    //     }
    //   });
    // });

    var that = this;  
    var doSubmit;
    var key = "";
    var entorno;
        if(localStorage.getItem("id_sucursal") == "1" || localStorage.getItem("id_sucursal") == "3" || localStorage.getItem("id_sucursal") == "7" || localStorage.getItem("id_sucursal") == "4"
        || localStorage.getItem("id_sucursal") == "5"  || localStorage.getItem("id_sucursal") == "8"  || localStorage.getItem("id_sucursal") == "9"  || localStorage.getItem("id_sucursal") == "10"
        || localStorage.getItem("id_sucursal") == "11"  || localStorage.getItem("id_sucursal") == "12"  || localStorage.getItem("id_sucursal") == "13"  || localStorage.getItem("id_sucursal") == "14"
        || localStorage.getItem("id_sucursal") == "15")
            entorno = "Productivo";
        else 
            entorno = "Sandbox"
    console.log(entorno);
    axios.get('/tokenML/' + localStorage.getItem("id_sucursal")+'/' + entorno, { headers: {Authorization: localStorage.getItem("token")} }).then(response => {
        console.log(response);
        // console.log(response);
        key = response.data[0].valor;
        // console.log(key);
        window.Mercadopago.setPublishableKey(key);

    }).catch(err => { console.log(err);})

    //  window.Mercadopago.setPublishableKey("TEST-4742fba6-1df5-4584-bfc7-b212f39ac605");
    // document.getElementById("cardNumber").addEventListener("keyup", guessPaymentMethod);
    document.getElementById("cardNumber").addEventListener("change", guessPaymentMethod);

    function guessPaymentMethod(event) {
      console.log(event);
        let cardnumber = document.getElementById("cardNumber").value;
        //alert(document.getElementById("cardNumber").value);
        if (cardnumber.length >= 6) {
            let bin = cardnumber.substring(0,6);
            window.Mercadopago.getPaymentMethod({
                "bin": bin
            }, setPaymentMethod);
        }
    }

    function setPaymentMethod(status, response) {
        if (status == 200) {
            let paymentMethodId = response[0].id;
            let element = document.getElementById('payment_method_id');
            element.value = paymentMethodId;
            getInstallments();
        } else {
            alert(`payment method info error: ${response}`);
        }
    }

    function getInstallments(){
        window.Mercadopago.getInstallments({
            "payment_method_id": document.getElementById('payment_method_id').value,
            "amount": parseFloat(document.getElementById('transaction_amount').value)

        }, function (status, response) {
            if (status == 200) {
                document.getElementById('installments').options.length = 0;
                response[0].payer_costs.forEach( installment => {
                    let opt = document.createElement('option');
                    opt.text = installment.recommended_message;
                    opt.value = installment.installments;
                    document.getElementById('installments').appendChild(opt);
                });
            } else {
                alert(`installments method info error: ${response}`);
            }
        });
    }


    doSubmit = false;
    document.querySelector('#pay').addEventListener('submit', doPay);

    function doPay(event){
        event.preventDefault();
        if(!doSubmit){
            var $form = document.querySelector('#pay');
            // console.log($form);

            window.Mercadopago.createToken($form, sdkResponseHandler);

            return false;
        }
    }

    function sdkResponseHandler(status, response) {
        if (status != 200 && status != 201) {
            alert("verify filled data");
        }else{
            var form = document.querySelector('#pay');
            var card = document.createElement('input');
            card.setAttribute('name', 'token');
            card.setAttribute('type', 'hidden');
            card.setAttribute('value', response.id);
            console.log(response);
            // alert(response.id);
            form.appendChild(card);
            // console.log(response);
            doSubmit=true;

            var cardTemp = {
              id_cliente: null,
              alias: null,
              id_sucursal:null,
              token_tc: null
            };
            // console.log("ID_CLIENTE: ", that.$store.state.id_cliente);
            cardTemp.id_cliente = that.$store.state.id_cliente;
            cardTemp.alias = that.card.alias ;
            cardTemp.token_tc = response.id;
            cardTemp.id_sucursal=localStorage.getItem("id_sucursal");
            // console.log(cardTemp);
            axios.post("/alta_cuenta", cardTemp, { headers: {Authorization: localStorage.getItem("token")} })
            .then(res => {
              console.log("Respuesta: ", res);
              // console.log("Mensaje: ", res.data.mensaje);
              if (res.data.mensaje == "Cuenta creada") {
                //that.$router.push({ name: "userprofile" });
              } else {
                that.alertmensaje = res.data.mensaje;
                that.$store.state.alertState = true;
                that.$store.state.alertMessage = that.alertmensaje;
                that.$store.state.alertColor = "error";
                setTimeout(() => {
                  that.$store.state.alertState = false;
                }, 4000); 
                // that.alert = true;
                // setTimeout(() => {
                //   that.alert = false;
                // }, 4000);
              }
            })
            .catch(error => {
              console.log(error);
            });
        }
    }

    document.querySelector('#cardNumber').addEventListener('keyup', guessPaymentMethod);
    document.querySelector('#cardNumber').addEventListener('change', guessPaymentMethod);
  },
  watch:{
        card_exp()
        {
            if(this.card_exp.length == 5 )
            {
                this.month=this.card_exp.substr(0,2);
                this.year=this.card_exp.substr(3,4);

                var currentYear = new Date().getFullYear().toString();
                currentYear = currentYear.substr(2,4) 
                // console.log(currentYear);

                var currentMonth = new Date().getMonth()+1
                if(currentMonth < 10) 
                  currentMonth = "0" + (new Date().getMonth()+1).toString();
                // console.log(currentMonth);
                if(parseInt(this.month) >= 1 && parseInt(this.month) <= 12)
                {
                  if(parseInt(this.year) > parseInt(currentYear))
                  {
                    console.log("Fecha correcta")
                  }
                  else if (parseInt(this.year) == parseInt(currentYear) && parseInt(this.month) >= parseInt(currentMonth))
                    console.log("Fecha correcta");
                  else
                  {
                    this.alertmensaje = "Fecha de expiración inválida";
                    this.$store.state.alertState = true;
                    this.$store.state.alertMessage = this.alertmensaje;
                    this.$store.state.alertColor = "error";
                    setTimeout(() => {
                        this.$store.state.alertState = false;
                    }, 4000); 
                    this.card_exp = "";
                    // console.log("Tarjeta expirada");
                  }
                }
                else
                {
                  this.alertmensaje = "Fecha de expiración inválida";
                    this.$store.state.alertState = true;
                    this.$store.state.alertMessage = this.alertmensaje;
                    this.$store.state.alertColor = "error";
                    setTimeout(() => {
                        this.$store.state.alertState = false;
                    }, 4000); 
                    this.card_exp = "";
                }
                // console.log(this.month);
                // console.log(this.year);
            }
        },
        'card.num': function () { 
          // console.log("Changing", this.card.num)
          //  console.log("UserCards", this.userCards)
          var first = 0, last = 0;
          let selector = document.getElementById("selector").value;
          if(selector.replace(/\s/g, '').length==19){
           first = 15, last = 19;
          //  console.log("Numbers: ", this.card.num.length-4, this.card.num.length)
          }
          else{
            first = 13, last = 18;
            // console.log("Menor a 19: ", first,last)
          }
          // console.log(this.card.num.slice(13,14) + this.card.num.slice(15,18));
          // console.log("Lenght", this.card.num.substr(first,last).length);
          // if(this.card.num.slice(13,14) + this.card.num.slice(15,18) == "7522")
          //   console.log("Worked")
          // console.log(this.card.num.substr(5,7));
          // console.log(this.userCards[0].digitos_inicial.substr(4,6))
          for(var i = 0; i < this.userCards.length ; i++)
          {
            if(this.card.num.substr(0,7).replace("-", "") == this.userCards[i].digitos_inicial)
            {
              // console.log("First are the same");
              if(last == 19)
              {
                if(this.card.num.substr(first,last).replace("-", "") == this.userCards[i].digitos_final)
                {
                  this.alertmensaje = "Esta tarjeta ya está registrada";
                  this.card.num = "";
                  this.$store.state.alertState = true;
                  this.$store.state.alertMessage = this.alertmensaje;
                  this.$store.state.alertColor = "error";
                  setTimeout(() => {
                      this.$store.state.alertState = false;
                  }, 4000); 
                  console.log("Same Card 19")
                }
              } 
              else {
                // console.log("Is 18");
                if(this.card.num.slice(13,14) + this.card.num.slice(15,18) == this.userCards[i].digitos_final)
                {
                  this.alertmensaje = "Esta tarjeta ya está registrada";
                  this.card.num = "";
                  this.$store.state.alertState = true;
                  this.$store.state.alertMessage = this.alertmensaje;
                  this.$store.state.alertColor = "error";
                  setTimeout(() => {
                      this.$store.state.alertState = false;
                  }, 4000); 
                  console.log("Same Card 18")
                }
              }
                
            }
            // console.log("UserCards", this.userCards[0])
          }
        },

  },
  methods: {
    generateToken() {
      this.loading = true;
      var _this = this;
      if (!!this.card.alias && !!this.card.name && !!this.card.num &&!!this.month && !!this.year && !!this.card.cvv){
        // console.log("CARD: ",this.card.num," ",this.card.num.length);
        // console.log("CVV: ",this.card.cvv," ",this.card.cvv.length);
        if ((this.card.num.replace(/\s/g, '').length == 19 && this.card.cvv.replace(/\s/g, '').length == 3) || (this.card.num.replace(/\s/g, '').length == 18 && this.card.cvv.replace(/\s/g, '').length == 4)){ 
          var refe = this;
          var $form = document.querySelector('#pay');
          var alias = this.card.alias;
          // console.log("Enter")
          // var router = this.$router;
          window.Mercadopago.createToken($form, function (status, response) {
            // var that = this;
            // console.log("Enter 2")
          if (status != 200 && status != 201) {
            console.log(status,response);
            _this.loading = false;
            // _this.alert = true;
            _this.alertmensaje = "Verifica tus datos ingresados"
            _this.$store.state.alertState = true;
            _this.$store.state.alertMessage = _this.alertmensaje;
            _this.$store.state.alertColor = "error";
            setTimeout(() => {
              _this.$store.state.alertState = false;
            }, 4000);
            // setTimeout(() => {
            //   _this.alert = false;
            // }, 2000);
              // alert("verify filled data");
          }else{
            // console.log("Enter 3")
              var form = document.querySelector('#pay');
              var carda = document.createElement('input');
              carda.setAttribute('name', 'token');
              carda.setAttribute('type', 'hidden');
              carda.setAttribute('value', response.id);
              console.log(response);
              form.appendChild(carda);
              
              var cardTemp = {
                id_cliente: null,
                alias: null,
                id_sucursal:null,
                token_tc: null
              };
              // console.log("ID_CLIENTE: ", localStorage.getItem("id_cliente"));
              cardTemp.id_cliente = localStorage.getItem("id_cliente");
              cardTemp.alias = alias;
              // router.push({ name: "userprofile" });
              console.log(cardTemp)
              cardTemp.token_tc = response.id;
              cardTemp.id_sucursal=localStorage.getItem("id_sucursal");
              // console.log("DATA: ",cardTemp);
              axios.post("/alta_cuenta", cardTemp, { headers: {Authorization: localStorage.getItem("token")} })
              .then(res => {
                console.log("Respuesta: ", res);
                // console.log("Mensaje: ", res.data.mensaje);
                if (res.data.mensaje == "Cuenta creada") {
                  refe.loading = false;
                  console.log("Cuenta creada")
                  refe.$router.push({ name: refe.route });
                } else {
                  refe.loading = false;
                  refe.alertmensaje = res.data.mensaje;
                  refe.$store.state.alertState = true;
                  refe.$store.state.alertMessage = refe.alertmensaje;
                  refe.$store.state.alertColor = "error";
                  setTimeout(() => {
                    refe.$store.state.alertState = false;
                  }, 4000);
                  // refe.alert = true;
                  // setTimeout(() => {
                  //   refe.alert = false;
                  // }, 4000);
                }
              })
              .catch(error => {
                console.log(error);
                refe.loading = false;
                refe.alertmensaje = "Algo salió mal, intentalo más tarde";
                  // refe.alert = true;
                  // setTimeout(() => {
                  //   refe.alert = false;
                  // }, 4000);
                refe.$store.state.alertState = true;
                refe.$store.state.alertMessage = refe.alertmensaje;
                refe.$store.state.alertColor = "error";
                setTimeout(() => {
                  refe.$store.state.alertState = false;
                }, 4000);
              });
          }
          });
          return false;
        }else {
          this.loading = false;
          this.$store.state.alertState = true;
          this.$store.state.alertMessage = "¡Error! Por favor verifica tu número de cuenta y CVV";
          this.$store.state.alertColor = "error";
          setTimeout(() => {
              this.$store.state.alertState = false;
          }, 4000); 
        }
      }else {
        this.loading = false;
        this.$store.state.alertState = true;
        this.$store.state.alertMessage = "¡Falta llenar algún campo!";
        this.$store.state.alertColor = "error";
        setTimeout(() => {
            this.$store.state.alertState = false;
        }, 4000); 
      }
    },
    async goTo() {
      // console.log("QUEDÉ", this.card);
      if (
        !!this.card.alias &&
        !!this.card.name &&
        !!this.card.num &&
        !!this.month &&
        !!this.year &&
        !!this.card.cvv
      ) {
        // console.log("QUEDÉ x2");
        if (
          (this.card.num.length == 19 && this.card.cvv.length == 3) ||
          (this.card.num.length == 18 && this.card.cvv.length == 4)
        ) {
          var cardTemp = {
            id_cliente: null,
            alias: null,
            id_sucursal:null,
            token_tc: null
          };
          console.log("ID_CLIENTE: ", this.$store.state.id_cliente);
          cardTemp.id_cliente = this.$store.state.id_cliente;
          cardTemp.alias = this.card.alias;
          cardTemp.token_tc = this.card.token;
          cardTemp.id_sucursal=localStorage.getItem("id_sucursal");
          await axios
            .post(
              "/alta_cuenta",
              cardTemp,
              { headers: { Authorization: this.$store.state.token } }
            )
            .then(res => {
              console.log("Respuesta: ", res);
              console.log("Mensaje: ", res.data.mensaje);
              if (res.data.mensaje == "Cuenta creada") {
                this.$router.push({ name: this.route });
              } else {
                this.alertmensaje = res.data.mensaje;
                this.$store.state.alertState = true;
                this.$store.state.alertMessage = this.alertmensaje;
                this.$store.state.alertColor = "error";
                setTimeout(() => {
                    this.$store.state.alertState = false;
                }, 4000); 
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          this.$store.state.alertState = true;
          this.$store.state.alertMessage = "¡Error! Por favor verifica tu número de cuenta y tu CVV";
          this.$store.state.alertColor = "error";
          setTimeout(() => {
              this.$store.state.alertState = false;
          }, 4000); 
        }
      } else {
        this.$store.state.alertState = true;
        this.$store.state.alertMessage = "¡Falta llenar algún campo!";
        this.$store.state.alertColor = "error";
        setTimeout(() => {
            this.$store.state.alertState = false;
        }, 4000); 
      }
    },
    disablePlease() {
      return this.card.name == "" ||
        this.card.num == "" ||
        this.card.exp == "" ||
        this.card.cvv == ""
        ? true
        : false;
    },
    print() {
      // console.log("EL COSO: ", this.card.num.length);
    }
  },
  created() {
    // console.log(localStorage.getItem('email'));
    this.$store.state.hideFooter = false;
    // axios.get(data.url, { headers: data.headers }).then(response => {
    //             //   console.log(response);
    //               resolve(response);
    //               commit
    //           }).catch(err => { reject(err);})
    // this.$store.dispatch("GET", {url: '/tokenML/' + localStorage.getItem("id_sucursal")+"/test", headers: {Authorization: localStorage.getItem("token")}})
    //     .then(response => {
    //         console.log(response);
            
    //     })
    //     .catch(error => {
    //         console.log("Error: " + error);
    //     });
  },
  beforeRouteEnter (to, from, next) {
      next(vm => {
      // console.log(to, from, next);
        if(from.name == "final_order")
          vm.route = "final_order";
        // console.log("Routering: " , vm.route);
    })
    }
};
</script>

<style scoped>
.btnDisabled:enabled {
  opacity: 1;
}

.btnDisabled:disabled {
  opacity: 0.7;
}
</style>